import React, {Component} from "react";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';

// Static options. `value` is what the API receives in filters.tat_status.
export const TAT_STATUS_OPTIONS = [
    {value: 'within_tat',  label: 'Within TAT'},
    {value: 'outside_tat', label: 'Outside TAT'},
];

// Default = both selected, i.e. no TAT filtering (same idea as the Ageing filter).
export const TAT_STATUS_DEFAULT = TAT_STATUS_OPTIONS.map(o => o.value);

class TatStatusFilter extends Component {
    state = {
        tatStatusValue: TAT_STATUS_OPTIONS.slice(),
    };

    resetTatStatusFilter() {
        this.setState({
            tatStatusValue: TAT_STATUS_OPTIONS.slice(),
        });
    }

    changeTatStatus(optionSelected) {
        const selected = optionSelected || [];
        const values = selected.map(o => o.value);
        this.props.onSelectTatStatus(selected, values);
        this.setState({
            tatStatusValue: selected,
        });
    }

    render() {
        return (
            <ReactMultiSelectCheckboxes name="tat_status"
                isMulti
                value={this.state.tatStatusValue}
                styles={reactSelectStyles} className="report-listbox"
                isClearable={false}
                onChange={this.changeTatStatus.bind(this)}
                options={TAT_STATUS_OPTIONS}
                placeholderButtonLabel="Select [TAT Status]"
            />
        );
    }
}
export default TatStatusFilter;
